<!--
  * name: Product
  * description: [Main] Product 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="products"></bread-crumb>
    <!-- 병헌 : 경로 -->
    <top-area /> <!-- 제목 비주얼 -->
    <hair @move-to-detail-page="moveToDetailPage" :products="hairCareProductList" />
    <body-list @move-to-detail-page="moveToDetailPage" :products="bodyCareProductList"/>
  </div>
</template>

<script>
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import productApi from '@/apis/product';
import TopArea from './partial/TopArea.vue';
import Hair from './partial/Hair.vue';
import BodyList from './partial/BodyList.vue';

export default {
  name: 'Product',
  components: {
    BreadCrumb,
    TopArea,
    Hair,
    BodyList,
  },
  data() {
    return {
      hairCareProductList: [],
      bodyCareProductList: [],
    };
  },
  created() {
    this.getProductList();
  },
  methods: {
    moveToDetailPage(productId) {
      this.$router.push({ name: 'ProductDetail', params: { productId } });
    },
    async getProductList() {
      const result = await productApi.getProducts();
      if (result.error) {
        return;
      }
      this.hairCareProductList = result.filter((item) => item.productsType.code === 'HAIR_CARE');
      this.bodyCareProductList = result.filter((item) => item.productsType.code === 'BODY_CARE');
    },
  },
};
</script>

<style lang='scss' scoped>
/deep/ .subtit{
  font-size: 2rem;
  font-weight: 500;
  color: #333333;
  padding-bottom: 2rem;
  @media (max-width: $mobile-size){
    padding-bottom: 1rem;
  }
}
/deep/ .list-style04--desc2{
  color: #4C9792;
}
@media (max-width: $mobile-size) {
  /deep/ .mt-10{
    margin-top: 1rem;
  }
}
</style>
